import React from 'react';
import PropTypes from 'prop-types';
import Button from '../button';
import {t} from 'common/utils/translation-util';
import './index.scss';

export default class ModalHeader extends React.Component {
  static propTypes = {
    buttons: PropTypes.any,
    children: PropTypes.any,
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
  };

  static defaultProps = {
    buttons: null,
    children: null,
    onCancel: null,
    onSave: null,
  };

  render() {
    return (
      <div className='ModalHeader'>
        <div className='ModalHeader-content'>
          {this.props.children}
          <div className='ModalHeader-button-group'>
            {this.props.onCancel ? (
              <span
                className='ModalHeader-cancel'
                onClick={this.props.onCancel}>
                {t('Cancel')}
              </span>
            ) : null}
            {this.props.onSave ? (
              <Button onClick={this.props.onSave} type='green'>
                {t('Save')}
              </Button>
            ) : null}
            {this.props.buttons}
          </div>
        </div>
      </div>
    );
  }
}
